import {createReducer} from '@reduxjs/toolkit'
import {GET_MY_TICKETS_OLD, getMyTickets} from '../actions/tickets'

const defaultState = {}

export const tickets = createReducer(defaultState, builder => {
  builder
    .addCase(getMyTickets.fulfilled, (state, action) => {
      state[action.meta.arg.eventId] = action.payload.tickets
    })
    .addMatcher(
      action => action.type === GET_MY_TICKETS_OLD.SUCCESS,
      (state, action) => {
        state[action.args[0]] = action.payload.tickets
      },
    )
})
